<template>
    <div class="privacy-general__info">
        {{ $t('I agree with the use of my personal data by Superbet through the means of communication ' +
            'provided to receive newsletters about general offers related to relevant products, campaigns or ' +
            'services.') }}
        <br>
        <StaticLink
            tag="a"
            class="action-text"
            path="declaratia-de-confidentialitate"
            target="_blank"
        >
            {{ $t('view the privacy statement') | capitalize }}
        </StaticLink>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('PrivacyConsentGeneralInfo', {
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/PrivacyConsentGeneralInfo.vue